module.exports = __webpack_public_path__ + "img/6-half-md.68c526f1.jpg";